import axios from 'axios'

import { getCountryAsAlpha2Code } from '@/constants/country'
import type { BidType, MarketProgram } from '@/features/bidding/constants'
import { PORTFOLIO_MANAGER_API_URL } from '@/features/bidding/endpoints/bids'
import type { MarketDate } from '@/features/bidding/utils/date/marketDate'

export type PricePrefillBid = {
  sourceDeliveryDay: string
  offeredPrices: number[]
}

// Keyed by activation group UUID.
export type PricePrefillBidsResponse = Record<string, PricePrefillBid>

export type PricePrefillBidsQueryParams = {
  country: CountryIdentifier
  portfolioCode: string
  marketProgram: MarketProgram
  bidType: BidType
  // Latest non-draft bid is resolved within [deliveryDay - 7, deliveryDay]. Pass the last
  // delivery day whose prices may be used to prefill (i.e. the day before the one being bid on).
  deliveryDay: MarketDate
}

export const getPricePrefillBids = async (params: PricePrefillBidsQueryParams): Promise<PricePrefillBidsResponse> => {
  const response = await axios.get(`${PORTFOLIO_MANAGER_API_URL}/price-prefill-bids`, {
    params: buildPricePrefillBidsParams(params),
  })
  return response.data
}

const buildPricePrefillBidsParams = (params: PricePrefillBidsQueryParams) => {
  const urlParams = new URLSearchParams()

  urlParams.append('countryCode', getCountryAsAlpha2Code(params.country))
  urlParams.append('marketProgram', params.marketProgram)
  urlParams.append('deliveryDay', params.deliveryDay.toISODate())
  urlParams.append('portfolioCode', params.portfolioCode)
  urlParams.append('bidType', params.bidType)

  return urlParams
}
